import { call, put, takeLatest } from "redux-saga/effects";
import { getErrorMessageString } from "utils/utils";
import apiService from "services/apiservice";
import { loadState } from "library/helpers/sessionStorage";
import {
  ADD_UPDATE_NAUTILUS_ITEMDETAILS_REQUEST,
  FETCH_NAUTILUS_ITEMDETAILS_LIST_REQUEST,
} from "./actionTypes";
import {
  addUpdateNautilusItemDetailsFailure,
  addUpdateNautilusItemDetailsSuccess,
  fetchNautilusItemDetailsListFailure,
  fetchNautilusItemDetailsListSuccess,
} from "./actions";
import { NautilusItemDetails } from "./types";

const currentUser = loadState("loggedInUser");
const token = currentUser?.accessToken;

const postRequest = async (url: string, payload: any) => {
  const { data } = await apiService.post(url, payload, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

function* fetchNautilusItemDetailsListSaga(action: any) {
  try {
    const response: NautilusItemDetails[] = yield call(
      postRequest,
      action.url,
      action.payload,
    );

    const totalCount =
      response && response.length > 0 && response[0]?.totalCount
        ? response[0].totalCount
        : 0;
    yield put(fetchNautilusItemDetailsListSuccess(response, totalCount));
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(fetchNautilusItemDetailsListFailure(errorMessage));
  }
}

function* addUpdateNautilusItemDetailsSaga(action: any) {
  try {
    const response: { status: string; message: string } = yield call(
      postRequest,
      action.url,
      action.payload,
    );
    yield put(addUpdateNautilusItemDetailsSuccess(response.message));
    action.callback("Success", response.message);
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(addUpdateNautilusItemDetailsFailure(errorMessage));
    action.callback("Error", errorMessage);
  }
}

export default function* nautilusItemDetailsSaga() {
  yield takeLatest(
    FETCH_NAUTILUS_ITEMDETAILS_LIST_REQUEST,
    fetchNautilusItemDetailsListSaga,
  );
  yield takeLatest(
    ADD_UPDATE_NAUTILUS_ITEMDETAILS_REQUEST,
    addUpdateNautilusItemDetailsSaga,
  );
}
